import { Button, InlineLink, Surface, Txt } from '@vst/beam';
import { useTranslation } from 'react-i18next';

const PlanCardCTA = ({
  callToOrder,
  handleClick,
  callToOrderMessage,
}: {
  callToOrder: boolean;
  handleClick: () => void;
  callToOrderMessage: string;
}) => {
  const { t } = useTranslation('ChangePlan');

  return (
    <Surface>
      {callToOrder ? (
        <InlineLink href={`tel: ${t('plan.callToOrder.phoneNumber')}`}>
          <Button fluid buttonSize="large" variant="secondary">
            <Txt variant="labelLarge">{callToOrderMessage}</Txt>
          </Button>
        </InlineLink>
      ) : (
        <Button buttonSize="large" fluid={true} variant="secondary" onClick={handleClick}>
          {t('plan.choosePlan')}
        </Button>
      )}
    </Surface>
  );
};

export default PlanCardCTA;
